import { render } from "./NewsflashEntry.vue?vue&type=template&id=566778ca"
import script from "./NewsflashEntry.vue?vue&type=script&lang=ts"
export * from "./NewsflashEntry.vue?vue&type=script&lang=ts"

import "./NewsflashEntry.vue?vue&type=style&index=0&id=566778ca&lang=scss"
script.render = render

export default script